import { classNames } from "../../../lib/class-names";
import BoxIcon from "../../ui/box-icon/box-icon";
import Button from "../../ui/button/button";
import { Fade, Slide, Zoom } from "react-awesome-reveal";

import "./hero-image.scss";

type HeroImagePropsT = {
  title: string;
  text: string;
  img: string;
  altImg: string;
  isMobile: boolean;
  video?: string;
  mobileVideo?: string;
  serviceText?: string;
  serviceIcon?: string;
  btnLeftText?: string;
  btnRightText?: string;
  btnLeftIconName?: string;
  btnRightIconName?: string;
  btnLeftHref?: string;
  btnRightHref?: string;
  certificationTitle?: string;
  certificationText?: string;
  certificationIcon?: string;
};

const HeroImage = ({
  title,
  text,
  img,
  video,
  mobileVideo,
  isMobile,
  altImg,
  serviceText,
  serviceIcon,
  certificationTitle,
  certificationText,
  certificationIcon,
  btnLeftText,
  btnRightText,
  btnLeftIconName,
  btnRightIconName,
  btnLeftHref,
  btnRightHref,
}: HeroImagePropsT) => {
  const heroClasses = classNames({
    "hero-image": true,
    "hero-image__has-badge": !!certificationTitle,
  });
  return (
    <section className={heroClasses}>
      <div className="hero-image__info-container">
        {serviceText && serviceIcon && (
          <Fade direction="up" triggerOnce duration={600}>
            <div className="hero-image__service">
              <BoxIcon icon={serviceIcon} size="medium" type="primary" />
              <span className="hero-image__service-text">{serviceText}</span>
            </div>
          </Fade>
        )}

        <Fade direction="up" triggerOnce duration={!!isMobile ? 600 : 800}>
          <div>
            <h1 className="hero-image__title">{title}</h1>
            <p className="hero-image__text">{text}</p>
          </div>
        </Fade>

        <Fade
          direction="up"
          triggerOnce
          duration={!!isMobile ? 600 : 800}
          delay={!!isMobile ? 0 : 200}
        >
          <div className="hero-image__buttons">
            {btnLeftHref && (
              <Button
                text={btnLeftText || ""}
                type="primary"
                iconName={btnLeftIconName}
                href={btnLeftHref}
              />
            )}
            {btnRightHref && (
              <Button
                text={btnRightText || ""}
                type="secondary"
                iconName={btnRightIconName}
                href={btnRightHref}
              />
            )}
          </div>
        </Fade>
      </div>

      <div className="hero-image__image-section">
        <Slide
          direction={!!isMobile ? "up" : "right"}
          triggerOnce
          duration={!!isMobile ? 600 : 1000}
        >
          <div className="hero-image__image-box">
            {!video ? (
              <img className="hero-image__img" src={img} alt={altImg} />
            ) : (
              <video
                className="hero-image__img"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                poster={img}
                aria-label={altImg}
              >
                <source
                  src={isMobile && !!mobileVideo ? mobileVideo : video}
                  type="video/mp4"
                />
                Il tuo browser non supporta il video.
              </video>
            )}

            {certificationText && certificationIcon && (
              <Zoom triggerOnce duration={700} delay={!isMobile ? 300 : 800}>
                <div className="hero-image__img-badge">
                  <BoxIcon
                    icon={certificationIcon}
                    size="small"
                    type="primary"
                  />
                  <div className="hero-image__img-text">
                    <span className="hero-image__img-text--title">
                      {certificationTitle}
                    </span>
                    <span className="hero-image__img-text--text">
                      {certificationText}
                    </span>
                  </div>
                </div>
              </Zoom>
            )}
          </div>
        </Slide>
      </div>
    </section>
  );
};

export default HeroImage;
